import { useTranslate } from '@im/react-localization';
import { NavItem } from '@im/ui-lib/mf-utils';
import { useIsEnvironment } from 'src/hooks/useIsEnvironment';
import { useRoles } from 'src/provider/UserRoleProvider';
import { useSearchParams } from 'react-router-dom';
import { useFeatureFlagEnabled } from 'src/hooks/useFeatureFlagEnabled';
import { IM_PRICING_GDE_UI_BEM_ENABLED } from 'src/util/constants';

export const queryParams: Record<string, Record<string, string>> = {
  '/discount/deals-list': {
    resellerId: '20222222',
  },
  '/enduser/enduser-dashboard': {
    customerNumber: '20222222',
  },
} as const;

export function useNavItems() {
  const { isCOGUser, isSuperAdminUser } = useRoles();
  const translate = useTranslate();
  const { isProdEnvironment } = useIsEnvironment();
  const [searchParams] = useSearchParams();
  const countryAccessLevel = process.env.REACT_APP_DM_Country_Code?.split(
    ','
  ).includes(searchParams.get('countryCode') ?? '');

  const isBEMEnabled = useFeatureFlagEnabled(IM_PRICING_GDE_UI_BEM_ENABLED);

  const navItems: NavItem[] = [
    {
      key: 'home',
      label: translate('Navigation.HomePage'),
      route: '/',
    },
    {
      key: 'bundles',
      label: translate('Navigation.CustomerGroups'),
      route: '/customer-groups/',
    },
    {
      hidden: isProdEnvironment,
      key: 'solutions',
      label: translate('Navigation.ProductGroups'),
      route: '/product-groups/',
    },
    {
      key: 'myBusiness',
      label: translate('Navigation.AdminPricing'),
      route: '/pricing/admin',
    },
    {
      key: 'business',
      label: translate('Navigation.Pricing'),
      route: '/pricing/new-rule',
    },
    {
      key: 'products',
      label: translate('Navigation.PricingApprovals'),
      route: '/pricing/approvals',
    },
    {
      key: 'services',
      label: translate('Navigation.Discount'),
      route: '/discount/deals-list',
    },
    {
      key: 'vendors',
      label: translate('Navigation.VendorPrograms'),
      route: '/vendor-program/program-list',
    },
    {
      hidden: isProdEnvironment,
      key: 'resources',
      label: translate('Navigation.IngramPrograms'),
      route: '/ingram-program/',
    },
    {
      key: 'dataingestion',
      label: translate('Navigation.BidLifeCycle'),
      route: '/bidlifecycle/bid-list',
    },
    {
      hidden: !countryAccessLevel,
      key: 'events',
      label: translate('Navigation.AcopMaintenance'),
      route: '/discount-management',
    },
    ...(isBEMEnabled
      ? [
          {
            key: 'bidManagementHub',
            label: translate('Navigation.BidManagementHub'),
            route: '/bid-management-hub',
          },
        ]
      : []),
    {
      hidden: !isCOGUser,
      key: 'auditLogs',
      label: translate('Navigation.AuditLogs'),
      route: '/audit-logs/logs-list',
    },
    {
      hidden: !isSuperAdminUser,
      key: 'settings',
      label: translate('Navigation.ManageUserRoles'),
      route: '/users/users-dashboard',
    },
  ];

  return navItems;
}
